// lib/license.ts
import { useI18n } from "vue-i18n";
import { LicenseType } from "../types/license";

export function useLicense() {
  const { t } = useI18n({
    inheritLocale: true,
    useScope: "global"
  });

  const getLicenseTypeName = (inLicenseType: string) => {
    switch(inLicenseType as LicenseType) {
      default:
      case LicenseType.Chorus:
        return t("license_type_Chorus");
      case LicenseType.TLE_Creator:
        return t("license_type_TLE_Creator");
      case LicenseType.TLE_Teacher:
        return t("license_type_TLE_Teacher");
      case LicenseType.Chorus_Optoma:
        return t("license_type_Chorus_Optoma");
    }
  };

  const getLicenseTypeTooltip = (inLicenseType: string) => {
    switch(inLicenseType as LicenseType) {
      default:
      case LicenseType.Chorus:
        return t("license_type_tooltip_chorus");
      case LicenseType.TLE_Creator:
        return t("license_type_tooltip_tle_creator");
      case LicenseType.TLE_Teacher:
        return t("license_type_tooltip_tle_teacher");
      case LicenseType.Chorus_Optoma:
        return t("license_type_tooltip_chorus_optoma");
    }
  };

  return {
    getLicenseTypeName,
    getLicenseTypeTooltip
  };
}